import {GET_LOGS, GET_ROLES, GET_USERS, GET_WEB_SERVICE_USERS, GET_WEBSERVICE_USER_INFO} from "../types";

const INITIAL_STATE = {
    entries:[],
    kind:'users',
    total:0,
    roles:[],
    reports:{entries:[],total:0,kind:'logs'}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_USERS:
            return {...state, ...action.payload};
        case GET_LOGS:
            return {...state, ...action.payload};
        case GET_WEB_SERVICE_USERS:
            return {...state, ...action.payload};
        case GET_WEBSERVICE_USER_INFO:
            return {...state, ...action.payload};
        case GET_ROLES:
            return {...state, ...action.payload};
        default:
            return state;
    }
};